import React, { FC, useContext, useState } from 'react';

import { H3, NumberInput, Toggle } from '@smartshell/ui-kit';

import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from '../OnlineBooking/OnlineBooking.module.scss';

export const SelfCancel: FC = () => {
  const { t } = useContext(LocalizationContext);

  const {
    state: {
      settings: {
        onlineBooking,
        onlineBookingCancel,
        onlineBookingCancelUntil,
        onlineBookingPenalty,
      },
    },
    actions: { setSetting },
  } = useContext(SettingsContext);

  const isAvailable = useIsFeatureAvailable('booking');

  const [until, setUntil] = useState<number | ''>(onlineBookingCancelUntil);
  const [errors, setErrors] = useState<Record<string, string | undefined>>({});
  const [penalty, setPenalty] = useState<number | ''>(onlineBookingPenalty);

  return (
    <>
      <div className={s.field}>
        <Toggle
          label={t('setting.onlineBooking.cancel')}
          description={t('settings.smartGamer.booking.cancel.description')}
          value={onlineBookingCancel}
          onChange={(value: boolean) =>
            setSetting({
              alias: ESettingsAliases.ONLINE_BOOKING_CANCEL,
              value: value ? '1' : '0',
            })
          }
          disabled={!onlineBooking || !isAvailable}
          variant="secondary"
          emptyBg
        />
        <div className={s.inputContainers}>
          <div className={s.inputContainer}>
            <H3>{t('setting.onlineBooking.cancel.until')}</H3>
            <NumberInput
              value={until}
              variant="secondary"
              onChange={(value) => {
                if (value === '' || value < 0) {
                  setErrors((prev) => ({
                    ...prev,
                    util: t('errors.min', '0', t('hour')),
                  }));
                } else if (value > 720) {
                  setErrors((prev) => ({
                    ...prev,
                    util: t('errors.max', 720, t('hour')),
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    util: undefined,
                  }));
                }

                setUntil(value);
              }}
              onBlur={() => {
                if (!errors.util && until !== onlineBookingCancelUntil)
                  return setSetting({
                    alias: ESettingsAliases.ONLINE_BOOKING_CANCEL_UNTIL,
                    value: until.toString(),
                  });
              }}
              error={errors.util}
              errorWrapperClassName={s.input}
              rightContent={t('time.contracted.hours')}
              bordered
              disabled={!onlineBookingCancel || !onlineBooking || !isAvailable}
            />
          </div>
          <div className={s.inputContainer}>
            <H3>{t('setting.onlineBooking.cancel.penalty')}</H3>
            <NumberInput
              value={penalty}
              variant="secondary"
              onChange={(value) => {
                if (value === '' || value < 0) {
                  setErrors((prev) => ({
                    ...prev,
                    penalty: t('errors.min', '0%'),
                  }));
                } else if (value > 100) {
                  setErrors((prev) => ({
                    ...prev,
                    penalty: t('errors.max', '100%'),
                  }));
                } else {
                  setErrors((prev) => ({
                    ...prev,
                    penalty: undefined,
                  }));
                }

                setPenalty(value);
              }}
              onBlur={() => {
                if (!errors.penalty && penalty !== onlineBookingPenalty)
                  return setSetting({
                    alias: ESettingsAliases.ONLINE_BOOKING_PENALTY,
                    value: penalty.toString(),
                  });
              }}
              error={errors.penalty}
              errorWrapperClassName={s.input}
              rightContent={'%'}
              bordered
              disabled={
                !onlineBookingCancel ||
                !onlineBooking ||
                !isAvailable ||
                !onlineBookingCancelUntil
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};
